import React from 'react';
import PropTypes from 'prop-types';
import { SIZES } from '../../../../constants';
import styles from '@dtsl/css-input/dist/index.module.css';
import { Text } from '@dtsl/react/dist/components/Text';

// eslint-disable-next-line react/display-name
const Suffix = /*#__PURE__*/React.memo(props => {
  const {
    suffix,
    size,
    id,
    accessibleSuffixText
  } = props;
  return suffix ? /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: "var(--sib-color_content-secondary)",
    size: "md",
    className: styles['sib-input-suffix'],
    id: `${id}-suffix`,
    style: {
      marginRight: size === SIZES.SMALL ? '8px' : '12px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-sr-only']
  }, accessibleSuffixText), typeof suffix === 'string' ? suffix : suffix()) : null;
});
export default Suffix;
Suffix.propTypes = {
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  size: PropTypes.string,
  id: PropTypes.string,
  accessibleSuffixText: PropTypes.string
};